module.exports = __webpack_public_path__ + "static/media/domisili.19d6fe74.png";